module.exports = __webpack_public_path__ + "img/QrCode.27c652dc.svg";